import { FC, Suspense } from 'react'

import { AnimatePresence } from 'framer-motion'
import { isDesktop } from 'react-device-detect'
import { createBrowserRouter, NonIndexRouteObject, Outlet, RouterProvider } from 'react-router-dom'

import { Authenticate } from '@shared/components/Authenticate'
import { FallbackNavigation } from '@shared/components/Fallback'
import { Sidebar, SidebarProvider } from '@shared/components/Sidebar'
import { Toast } from '@shared/components/Toast'
import { GlobalProvider } from '@shared/providers/GlobalProvider'

import { Auth } from '@modules/auth/pages/Auth'

import { ErrorPage } from './ErrorPage'
import { Routes as InternalRoutes } from './Routes'

export type RouteObject = NonIndexRouteObject & { title: string }

export const Routes: FC = () => {
  const privateRoutes = InternalRoutes.privateRoutes.map((route) => {
    return {
      path: route.path,
      element: (
        <section className="flex h-full">
          <SidebarProvider>
            <Toast />

            {isDesktop ? <Sidebar.Desktop /> : <Sidebar.Mobile />}

            <Suspense fallback={<FallbackNavigation />}>
              <Authenticate>
                <section className="bg-background-primary flex h-full min-h-screen w-full lg:ml-64">
                  <section className="mx-auto h-full w-full max-w-5xl">{route.element}</section>
                </section>
              </Authenticate>
            </Suspense>
          </SidebarProvider>
        </section>
      ),
    }
  })

  const router = createBrowserRouter([
    {
      element: <Auth />,
      ErrorBoundary: ErrorPage,
      path: '/auth',
    },
    {
      children: [...privateRoutes],
      element: (
        <AnimatePresence>
          <Outlet />
        </AnimatePresence>
      ),
      ErrorBoundary: ErrorPage,
      path: '/',
    },
  ])

  return (
    <Suspense fallback={<FallbackNavigation />}>
      <GlobalProvider>
        <RouterProvider router={router} />
      </GlobalProvider>
    </Suspense>
  )
}
